import { render, staticRenderFns } from "./NIFPS.vue?vue&type=template&id=693d7d7c&scoped=true"
import script from "./NIFPS.vue?vue&type=script&lang=js"
export * from "./NIFPS.vue?vue&type=script&lang=js"
import style0 from "./NIFPS.vue?vue&type=style&index=0&id=693d7d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693d7d7c",
  null
  
)

export default component.exports